var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",staticStyle:{"overflow":"hidden"}},[_c('div',{ref:"canvas",staticStyle:{"height":"300px","width":"600px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }